import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { ts, validatePhoneNumber } from "../utils/metaData";
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';


const BookingForm = ({ isOpen, setIsOpen }) => {
   const [loading, setLoading] = useState(false)

  const [data, setData] = useState({
    name: '',
    phone: '',
    pickup: '',
    drop: '',
    email: ''
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.name || !data.phone || !data.drop || !data.pickup || !data.email) {
      toast.error("All fields are required.");
      return;
    }

    if (!validatePhoneNumber(data.phone)) {
      toast.error("Invalid Phone Number");
      return;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        "pid": "INVST"
      }

      const body = JSON.stringify({
        meta: {
          pid: "INVST",
          appName: "bestcab",
          ts: ts(),
          reqAction: "connect",
          location: "N/A",
        },
        pay: {
          phone: data.phone,
          name: data.name,
          pickup: data.pickup,
          drop: data.drop,
          email: data.email
        }
      })
   setLoading(true)  
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/user/bestcab/connect`, {
        method: "POST",
        body: body,
        headers: headers,
      })
      const res = await response.json()
         setLoading(false)  
      if (res.statusCode == '000') {
        toast.success(res.message)
        setIsOpen(false)
      }
      else {
        toast.error(res.message)
      }
      setData({
        name: "",
        phone: "",
        pickup: "",
        drop: "",
        email: ""
      })
    } catch (error) {
      toast.error("Something Went Wrong !");
    }finally{
       setLoading(false)  
    }
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 px-6 sm:px-8 md:px-20 pt-24">
      <div className="relative w-full sm:w-3/4 md:w-1/2 lg:w-1/3 bg-white bg-opacity-30 backdrop-blur-md p-6 rounded-lg shadow-lg text-black">
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-4 right-4 text-white hover:text-pink-500 transition"
        >
          <X size={24} />
        </button>

        <h2 className="text-2xl font-semibold text-center mb-4 text-white">
          Book Your Ride
        </h2>

        <form className="space-y-4">
          <input
            type="text"
            name="name"
            value={data.name}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
            placeholder="Name"
            required
          />
          <input
            type="text"
            name="phone"
            value={data.phone}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
            placeholder="Phone Number"
            required
          />
          <input
            type="mail"
            name="email"
            value={data.email}
            placeholder="Email"
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
            required
          />
          <input
            type="text"
            name="pickup"
            value={data.pickup}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
            placeholder="Pickup location"
            required
          />
          <input
            type="text"
            name="drop"
            value={data.drop}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
            placeholder="Drop location"
            required
          />
          <button
            type="submit"
            className="w-full bg-pink-600 text-white py-2 rounded-lg hover:bg-pink-500 transition flex justify-center items-center gap-2"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? (
              <AiOutlineLoading3Quarters className="animate-spin text-xl" />
            ) : (
              'Submit'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BookingForm;